import { Route, Routes } from 'react-router';
import { Loading, parseErrorToString } from '@shared';
import { Flex } from '@chakra-ui/react';
import { type UseQueryResult } from '@tanstack/react-query';
import { AuthProvider, Login, SessionExpired, SuperadminRoutes, useGetSelf, useSuperadminAuth } from '@superadmin';

const TOKEN_NAME = import.meta.env.VITE_SUPERADMIN_TOKEN_NAME as string;

function Router() {
	const { user } = useSuperadminAuth();
	return (
		<Routes>
			<Route path="/sessionExpired" element={<SessionExpired />} />

			<Route path="*" element={user ? <SuperadminRoutes /> : <Login />} />
		</Routes>
	);
}

export default function AuthWrapper() {
	const storedAccountID = localStorage.getItem('tavoittaja2AccountID');

	function getToken(): string | null {
		const token = localStorage.getItem(TOKEN_NAME);
		return token || null;
	}

	const {
		data: user,
		isFetching: isPendingUser,
		error: userError,
	} = useGetSelf({
		isEnabled: !!getToken(),
	}) as UseQueryResult<User>;

	if (isPendingUser) {
		return (
			<Flex justifyContent="center" alignItems="center" height="100vh">
				<Loading />
			</Flex>
		);
	}

	if (userError) {
		localStorage.removeItem(TOKEN_NAME);
		throw new Error(parseErrorToString(userError));
	}

	if (!user) {
		localStorage.removeItem(TOKEN_NAME);
	}

	return (
		<AuthProvider defaultUser={user || null} defaultAccountID={user && storedAccountID ? parseInt(storedAccountID) : null}>
			<Router />
		</AuthProvider>
	);
}
